import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { EstatusJSON } from '../../models/EstatusJSON';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';
@Injectable({
  providedIn: 'root'
})
export class FunctionGpsAPIService implements IApiBase {
  configUrl: string;
  headers: HttpHeaders;
  constructor(private http: HttpClient, private router: Router) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }

  getReportHist(initialDate: string, finalDate: string, identifier: string = ""): any {
    if(!environment.production) console.log("/api/FunctionsGPSActions/GetHistoryReport?initialDate={"+initialDate+"}&finalDate={"+finalDate+"}&identifier="+identifier);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/FunctionsGPSActions/GetHistoryReport?initialDate="+initialDate+"&&finalDate="+finalDate+"&&identifier="+identifier,{});
  }

  getReportHabits(initialDate: string, finalDate: string, identifier: string): any {
    if(!environment.production) console.log("/api/FunctionsGPSActions/GetHabitsReport?initialDate={"+initialDate+"}&finalDate={"+finalDate+"}&identifier="+identifier);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/FunctionsGPSActions/GetHabitsReport?initialDate="+initialDate+"&&finalDate="+finalDate+"&&identifier="+identifier,{});
  }

  getReportStatistics(initialDate: string, finalDate: string, identifier: string): any {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/FunctionsGPSActions/GetStatisticsReport?initialDate="+initialDate+"&&finalDate="+finalDate+"&&identifier="+identifier,{});
  }

}
